import { Injectable } from '@angular/core';
import { DbRecord } from './db-record'
import { RTagGroupService } from './r-tag-group.service'

@Injectable()
export class PageService {
  recordsLength: number;
  pageLength = 50;
  currentStart = 0;
  lastRecords: DbRecord[] = [];

  constructor(private rTags: RTagGroupService) { }

  getPage(ls: DbRecord[]) {
    this.lastRecords = ls;
    let records = ls.slice(this.currentStart, this.currentStart + this.pageLength);
     // this.rTags.checkRecords(records)
    /*
    if (this.rTags.checkRecords(records)) {
      this.rTags.preloadRecords(ls.slice(this.currentStart + this.pageLength));
    } */
    return records;
  }

  nextPage() {
    let newStart = this.currentStart + this.pageLength;
    if (newStart < this.lastRecords.length) {
      this.currentStart = newStart;
    }
  }

}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/page.service.ts